<template>
  <div v-if="cardTypeList.length > 0 || (cardTypeList.length == 0 && !isStore)" class="pack_menu_list">
    <!-- 新しいUI: 7oripa風、1段4タイトル、最大2段 -->
    <div
      v-for="cardType in displayedCardTypes"
      :key="cardType.id"
      class="pack_menu"
      :class="{ active: showCardType == cardType.id, bonus: cardType.id === 999995 }"
      @click="selectPackType(cardType.id)"
    >{{ t(cardType.name) }}</div>
    <!-- 空の要素で4の倍数に揃える -->
    <div
      v-for="n in emptySlots"
      :key="'empty-' + n"
      class="pack_menu empty"
    ></div>
  </div>

  <!-- 既存のUI（コメントアウト） -->
  <!-- <div v-if="cardTypeList.length > 0 || (cardTypeList.length == 0 && !isStore)" class="pack_menu_list_old">
    <div class="menu-wrapper">
      <div v-if="cardTypeList.length == 0" class="menu" id="menu">
        <div
          class="menu-item"
          id="menu-item"
          :class="{ active: showCardType == 999996 }"
          @click="selectPackType(999996)"
        >MIX</div>
        <div
          class="menu-item"
          :class="{ active: showCardType == 2 }"
          @click="selectPackType(2)"
          >Pokemon</div>
        <div
          class="menu-item"
          :class="{ active: showCardType == 1 }"
          @click="selectPackType(1)"
        >Yu-Gi-Oh</div>
        <div
          class="menu-item"
          :class="{ active: showCardType == 5 }"
          @click="selectPackType(5)"
        >ONE PIECE</div>
        <div
          class="menu-item"
          :class="{ active: showCardType == 3 }"
          @click="selectPackType(3)"
        >Weiss Schwarz</div>
        <div
          class="menu-item"
          :class="{ active: showCardType == 9999 }"
          @click="selectPackType(9999)"
          >Hobby</div>
      </div>
      <div class="menu" id="menu">
        <div
          v-for="cardType in cardTypeList"
          :key="cardType.id"
          class="menu-item"
          :class="{ active: showCardType == cardType.id }"
          @click="selectPackType(cardType.id)"
        >{{ t(cardType.name) }}</div>
      </div>
    </div>
  </div> -->
</template>

<script>
import t from '@/plugins/i18n';
import { mapGetters } from 'vuex';

export default {
  mixins: [t],

  computed: {
    ...mapGetters({
      showCardType: 'pack/topCardType',
    }),
    // 最大8タイトル（4×2段）を表示
    displayedCardTypes() {
      return this.cardTypeList.slice(0, 8);
    },
    // 4の倍数に揃えるための空スロット数
    emptySlots() {
      const count = this.displayedCardTypes.length;
      if (count === 0) return 0;
      const remainder = count % 4;
      return remainder === 0 ? 0 : 4 - remainder;
    },
  },
  props: {
    cardTypeList: {
      type: Array,
      default: () => [],
    },
    isStore: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    scrollAmount: 0,
    scrollStep: 0,
  }),

  methods: {
    selectPackType(type) {
      this.$store.dispatch('pack/setTopCardType', type);
    },
    initializeScroll() {
      const menuItem = document.querySelector('.menu-item');
      this.scrollStep = menuItem ? menuItem.clientWidth : 0;
    },
    scrollRight() {
      const menu = document.querySelector('.menu-wrapper');
      this.initializeScroll();
      const maxScroll = menu.scrollWidth - menu.clientWidth;
      const newScrollAmount = Math.min(menu.scrollLeft + this.scrollStep, maxScroll);
      this.smoothScroll(menu, newScrollAmount);
    },
    scrollLeft() {
      const menu = document.querySelector('.menu-wrapper');
      this.initializeScroll();
      const newScrollAmount = Math.max(menu.scrollLeft - this.scrollStep, 0);
      this.smoothScroll(menu, newScrollAmount);
    },
    smoothScroll(element, targetPosition) {
      element.scrollTo({
        left: targetPosition,
        behavior: 'smooth',
      });
    },
    enableDragScroll() {
      const menu = document.querySelector('.menu-wrapper');
      let isDown = false;
      let startX;
      let scrollLeft;
      // PCのドラッグスクロール
      menu.addEventListener('mousedown', (e) => {
        isDown = true;
        startX = e.pageX - menu.offsetLeft;
        scrollLeft = menu.scrollLeft;
        menu.style.cursor = 'grabbing';
      });

      menu.addEventListener('mouseleave', () => {
        isDown = false;
        menu.style.cursor = 'grab';
      });

      menu.addEventListener('mouseup', () => {
        isDown = false;
        menu.style.cursor = 'grab';
      });

      menu.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - menu.offsetLeft;
        const walk = (x - startX) * 2; // スクロール速度調整
        menu.scrollLeft = scrollLeft - walk;
      });

      // スマホのスワイプスクロール
      let touchStartX;
      let touchScrollLeft;

      menu.addEventListener('touchstart', (e) => {
        touchStartX = e.touches[0].pageX - menu.offsetLeft;
        touchScrollLeft = menu.scrollLeft;
      });

      menu.addEventListener('touchmove', (e) => {
        e.preventDefault();
        const x = e.touches[0].pageX - menu.offsetLeft;
        const walk = (x - touchStartX) * 2; // スクロール速度調整
        menu.scrollLeft = touchScrollLeft - walk;
      });
    },
  },
  mounted() {
    // 新しいグリッドUIではドラッグスクロール不要
    // this.enableDragScroll();
    // 初期選択はTop.vueのpackList watchで行うため、ここでは行わない
  },
};
</script>

<style lang="scss" scoped>
/* 新しいUI: 7oripa風、1段4タイトル、最大2段 */
.pack_menu_list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background-color: $white;
  margin: 0 0 20px 0;
  flex-wrap: wrap;
  width: 100vw;
  margin-left: calc(-50vw + 50%);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  clip-path: inset(0 0 -10px 0);
  position: relative;

  /* 1段目の下に一直線の影 */
  &::after {
    content: '';
    position: absolute;
    top: 70px;
    left: 0;
    width: 100%;
    height: 6px;
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0.12), transparent);
    z-index: 10;
    pointer-events: none;
  }

  .pack_menu {
    color: $black;
    flex: 0 0 25%;
    max-width: 25%;
    height: 70px;
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: .2s;
    font-weight: bold;
    font-size: 14px;
    box-sizing: border-box;
    background-color: $white;

    &:hover {
      background-color: #f0f0f0;
    }

    &.active {
      background-color: #e8e8e8;
      border-bottom: 5px solid #e53935;
    }

    &.empty {
      cursor: default;
      &:hover {
        background-color: $white;
      }
    }

    &.bonus {
      color: transparent;
      background: linear-gradient(to bottom, #ffe600, #cc5500);
      background-clip: text;
      -webkit-background-clip: text;
      font-weight: 900;
      text-transform: uppercase;

      &.active {
        background: linear-gradient(to bottom, #ffe600, #cc5500), #e8e8e8;
        background-clip: text, padding-box;
        -webkit-background-clip: text, padding-box;
      }
    }
  }
}

@media screen and (max-width: $tabletWidth) {
  .pack_menu_list {
    justify-content: flex-start;
    &::after {
      top: 54px;
    }
    .pack_menu {
      height: 54px;
      flex: 0 0 25%;
      max-width: 25%;
      font-size: 12px;
    }
  }
}

@media screen and (max-width: 480px) {
  .pack_menu_list {
    justify-content: flex-start;
    &::after {
      top: 48px;
    }
    .pack_menu {
      height: 48px;
      font-size: 10px;
    }
  }
}

/* 既存のUI用スタイル（コメントアウト） */
/*
.pack_menu_list_old {
  display: flex;
  align-items: center;
  overflow: hidden;
  border-radius: 20px;
  border: 1px solid #ddd;
  padding: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.6);
  margin-bottom: 15px;
}
.arrow {
  width: 50px;
  height: 50px;
  cursor: pointer;
}
.menu-wrapper {
  overflow: hidden;
  width: 100%;
}
.menu {
  display: flex;
  transition: transform 0.3s ease;
  gap: 10px;
  user-select: none;
  white-space: nowrap;
}
.menu-item {
  flex: 0 0 auto;
  padding: 5px 5px;
  font-size: 18px;
  color: $gray2;
  white-space: nowrap;
  width: 20%;
  text-align: center;
  font-weight: bold;
  overflow: hidden;
  cursor: pointer;
}
.menu-item.active {
  background-color: #f0a380;
  color: $white;
  border-radius: 20px;
  width: 23%;
}
@media screen and (max-width: $tabletWidth) {
  .pack_menu_list_old {
    margin: 10px 0;
  }
  .arrow {
    width: 25px;
    height: 25px;
  }
  .menu-item {
    padding: 7px 2px;
    font-size: 10px;
    min-width: 70px;
    width: auto;
  }
  .menu-item.active {
    width: auto;
  }
}
*/
</style>
